export default function(instance){
    return{
        Commit(payload){
            return instance.put("/CompanyUserCompanyBrand/Commit", payload);
        },
    }
}
